import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
// import RoomGroupBuilderTabs from "./RoomGroupBuilderTabs"
import RoomGroupBuilderWorkspace from "./RoomGroupBuilderWorkspace";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import RoomGroupBuilderErrors from './RoomGroupBuilderErrors';

class RoomGroupBuilder extends React.Component {

  constructor(props) {
    super(props)
    var self = this
    if(this.props.rooms){
      var room_ids = this.props.rooms.map(room => {
        return room.id
      })
    } else {
      return null
    }
    this.state = {
      active_tab: this.props.active_tab ? this.props.active_tab : 'general',
      loading: false,
      errors: this.props.errors ? this.props.errors : {},
      is_new: this.props.is_new ? this.props.is_new : false,
      all_room_types: this.props.all_room_types ? this.props.all_room_types : [],
      all_rooms: this.props.all_rooms ? this.props.all_rooms : [],
      rooms: this.props.rooms,
      room: this.props.room || null,
      room_type: this.props.room_type || null,
      room_ids: room_ids,
      room_identifiers: this.props.room_identifiers ? this.props.room_identifiers : [],
      room_group_id: this.props.room_group_id ? this.props.room_group_id : [],
      room_group_create_path: this.props.room_group_create_path,
      room_group_save_path: this.props.room_group_save_path,
      identifier: this.props.identifier || "",

    }
    this.setActiveTab = this.setActiveTab.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onIdentifierChange = this.onIdentifierChange.bind(this)
    this.onChangeRoomType = this.onChangeRoomType.bind(this)
    this.onRoomsChange = this.onRoomsChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidUpdate(){
    if (typeof initTypeahead == 'function' && this.refs.root) {
      window.initTypeahead($(this.refs.root).find("[data-model][data-column]"));
    }
  }

  render(){
    var self = this
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]
    return(
      <div className="RoomTypeBuilder">
        <Tabs tabs={this.tabs()} displayErrorMessage={(RoomGroupBuilderErrors.general(this.state.errors).length || RoomGroupBuilderErrors.room_type(this.state.errors).length) ? true : false} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons}/>
          {/* <RoomGroupBuilderTabs
            {...this.state}
            active_tab={this.state.active_tab}
            setActiveTab={this.setActiveTab}/> */}
          <RoomGroupBuilderWorkspace
            {...this.state}
            onChange={this.onChange}
            onIdentifierChange={this.onIdentifierChange}
            onChangeRoomType={this.onChangeRoomType}
            onRoomsChange={this.onRoomsChange}/>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  };

  tabs(){
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.setActiveTab,
          tabErrorCount: RoomGroupBuilderErrors.general(this.state.errors).length
        },
        {
          tabName: I18n.t('room_types'),
          targetName: 'room-types',
          classes: this.state.active_tab === 'room-types' ? 'active' : null,
          changeHandler: this.setActiveTab,
          tabErrorCount: RoomGroupBuilderErrors.room_type(this.state.errors).length
        },
        {
          tabName: I18n.t('rooms'),
          targetName: 'rooms',
          classes: this.state.active_tab === 'rooms' ? 'active' : null,
          changeHandler: this.setActiveTab,
        },
      ]
    );
  };

  setActiveTab(name) {
    this.setState({active_tab: name})
  }

  onChange(event) {
    this.state[event.target.name] = event.target.value;
    this.forceUpdate();
  }

  onIdentifierChange(event) {
    this.setState({
      identifier: event.target.value
    })
  }

  onChangeRoomType(event) {
    var room_type_id = null
    if(event.target.value.length) room_type_id = event.target.value
    var room = {...this.state.room}
    room.room_type_id = room_type_id
    room.room_type_ids = [room_type_id]
    this.setState({
      room: room
    })
  }

  onRoomsChange(room_ids) {
    let result = []
    for(let i = 0; i < room_ids.length; i++){
      for(let j = 0; j < this.props.all_rooms.length; j++) {
        if(room_ids[i] === this.props.all_rooms[j].id){
          result.push(this.props.all_rooms[j].identifier)
        }
      }
    }
    this.setState({
      room_ids: room_ids,
      room_identifiers: result
    })

    var identifier_has_ids = true

    var ids = this.state.identifier ? this.state.identifier.split(", ") : []
    var all_room_ids = this.state.all_rooms.map(room => room.identifier)
    for (let i = 0; i < ids.length; i++) {
      if (!all_room_ids.includes(ids[i])) {
        identifier_has_ids = false
      }
    }

    if(identifier_has_ids || !this.state.identifier) {
      result = result.sort()
      this.setState({
        identifier: result.join(", ")
      })
    }
  }

  onSubmit(){
    var self = this
    var room_group = {
      room_ids: self.state.room_ids,
      identifier: self.state.identifier || self.state.room_identifiers.join(", "),
      room_type_id: self.state.room.room_type_id
    }
    self.setState({ loading: true })
    setTimeout(function () {
      $.ajax({
        type: self.state.is_new ? 'POST' : 'PATCH',
        url: self.state.is_new
                ? self.state.room_group_create_path
                : self.state.room_group_save_path,
        data: {
          room_group: room_group
        }
      }).done(function (data) {
        if(Object.keys(data.errors).length){
          self.setState({ loading: false })
          self.setState({errors: data.errors})
        }
        else {
          self.setState({ loading: false })
          if (parent && parent.refresh_data) {
            if (self.props.is_new == true) {
              parent.refresh_data(I18n.t('room_group_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('room_group_saved_successfully'));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal()
          }
        }
      })
    }, 1000)
  }

}

export default RoomGroupBuilder
